import type React from 'react';
import {Stack} from '@mui/material';
import {useRiskScoreQuery} from '../hooks/useCategoryProfileQueries';
import {riskExplanation} from '../domain/riskScore';

type Props = {
    databagId: number;
    path: string;
    /** Shown when the explanation cannot be loaded. */
    fallback: string;
};

/** Why a category has its risk level. A tooltip mounts it only while open, so the explanation is fetched on hover. */
export const RiskExplanation: React.FC<Props> = ({databagId, path, fallback}) => {
    const {data, isError} = useRiskScoreQuery(databagId, path);
    const lines = data?.risk ? riskExplanation(data.risk) : isError || data ? [fallback] : null;
    if (!lines) return <span>Loading…</span>;
    return <Stack gap={0.5}>{lines.map(l => <span key={l}>{l}</span>)}</Stack>;
};
